import styled from "styled-components";

export const RatingContainer = styled.div`
  .rating-progress-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 120px;
    b {
      margin-left: 10px;
      font-size: 16px;
      width: 200px;
    }
  }
  .head-rating {
    @media (max-width: 800px) {
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`;

export const RatingRight = styled.div`
  flex: 1;
`;